import React, { type FunctionComponent } from 'react';

interface StarProps {
  className?: string;
  fill?: string;
  stroke?: string;
}

const Star: FunctionComponent<StarProps> = ({
  className,
  fill = '#FFCD1E',
  stroke = 'transparent',
}) => (
  <svg
    className={className}
    fill="none"
    height="35"
    viewBox="0 0 40 35"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
  >
    {fill && (
      <path
        d="M32.7391 32.1391C33.3019 34.2969 32.0302 35.1331 29.8926 33.9834L19.9998 28.6627L10.1071 33.9834C7.97973 35.1276 6.69506 34.3073 7.26058 32.1391L9.87785 22.1044L1.14563 15.356C-0.732135 13.9049 -0.254422 12.5615 2.23287 12.3712L13.744 11.4903L18.2406 2.02951C19.2075 -0.00492835 20.7875 -0.014742 21.7591 2.02951L26.2557 11.4903L37.7668 12.3712C40.2422 12.5606 40.7409 13.8979 38.8541 15.356L30.1218 22.1044L32.7391 32.1391Z"
        fill={fill}
      />
    )}
    {stroke && (
      <path
        d="M20 1.5C20.0528 1.4999 20.4293 1.56227 20.8555 2.45898L25.3525 11.9199L25.6016 12.4434L26.1797 12.4873L37.6904 13.3682C38.2331 13.4097 38.5967 13.5101 38.8145 13.6143C38.9122 13.661 38.9645 13.7013 38.9912 13.7256C38.9843 13.7475 38.9727 13.7808 38.9482 13.8262C38.8577 13.9939 38.6493 14.2499 38.2422 14.5645L29.5107 21.3135L28.9873 21.7168L29.1543 22.3564L31.7715 32.3916C31.8878 32.8377 31.8865 33.1334 31.8525 33.3018C31.8364 33.3813 31.8148 33.4228 31.8037 33.4404C31.794 33.4558 31.7878 33.4609 31.7832 33.4639C31.7758 33.4687 31.6881 33.5212 31.4385 33.4912C31.1867 33.4608 30.827 33.3504 30.3662 33.1025L20.4736 27.7822L20 27.5273L19.5264 27.7822L9.63379 33.1025C9.17571 33.3489 8.81684 33.4594 8.56445 33.4902C8.31297 33.5209 8.22369 33.468 8.21582 33.4629C8.2111 33.4598 8.20461 33.4551 8.19531 33.4404C8.18445 33.4232 8.16352 33.3823 8.14746 33.3037C8.11333 33.1362 8.11149 32.8403 8.22852 32.3916L10.8457 22.3564L11.0127 21.7168L10.4893 21.3135L1.75684 14.5645C1.35244 14.2519 1.14402 13.9965 1.05273 13.8281C1.02731 13.7812 1.01472 13.747 1.00781 13.7246C1.03419 13.7006 1.08615 13.6616 1.18262 13.6152C1.39954 13.5111 1.76367 13.4099 2.30957 13.3682L13.8203 12.4873L14.3984 12.4434L14.6475 11.9199L19.1436 2.45898C19.5676 1.56682 19.945 1.50012 20 1.5Z"
        stroke={stroke}
        strokeWidth="3"
      />
    )}
  </svg>
);

export default Star;
